import { render } from "./RequestSent.vue?vue&type=template&id=13816881&scoped=true"
import script from "./RequestSent.vue?vue&type=script&lang=js"
export * from "./RequestSent.vue?vue&type=script&lang=js"

import "./RequestSent.vue?vue&type=style&index=0&id=13816881&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13816881"]])

export default __exports__